module.exports = __webpack_public_path__ + "media/images/user/favicons/apple-touch-icon-120x120-precomposed-ac3d6da6bae273a270830b8778775fec.png";